import { iframeResizer } from 'iframe-resizer';

const $iframe = $('.api-iframe');

const postMessageresizeIframe = () => {
    if ($iframe.length > 0) {
        iframeResizer({}, '.api-iframe');
    }
}

const init = () => {
    postMessageresizeIframe();
}

export default init;